import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Minimal';

    // override the default Preset here
}
